import { TFolder } from '@/api/queries/project/useGetProjectFolders';
import { Location, LocationDescriptor } from 'history';

export const buildFolderToPath =
  (baseURL: string, folder?: TFolder) =>
  (location: Location): LocationDescriptor => {
    return {
      ...location,
      pathname: folder?.isRoot
        ? baseURL
        : `${baseURL}${folder ? `/${folder.id}` : ''}`,
    };
  };
